var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-Logged-In-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-25.000000, -591.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.000000, 592.000000)",
    stroke: "#363636"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3642",
    points: "8.4375 11.1363636 8.4375 13.6818182 0.3125 13.6818182 0.3125 0.318181818 8.4375 0.318181818 8.4375 2.86363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4375,7.31818182 L14.6875,7.31818182",
    id: "Stroke-3643"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3644",
    points: "11.5625 4.13636364 14.6875 7.31818182 11.5625 10.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6015aec76e23a2fb948ac02cc7cb067b.svg";
export { ForwardRef as ReactComponent };